module.exports = __webpack_public_path__ + "img/Maddie.7df2bbe.png";